import { alpha, createTheme } from "@mui/material";
import { sharedPalette } from "./sharedPalette";

export const artemisLight = createTheme({
  palette: {
    ...sharedPalette,
    mode: "light",
    primary: {
      main: "#9147FF",
      light: "#A07AFF",
      dark: "#5000C1",
      contrastText: "#FFFFFF",
      gradient: "linear-gradient(180deg, #9147FF 0%, #3F137C 100%)",
    },
    error: {
      main: "#FF5252",
      //   Following error values are just placeholders
      light: "#FF7B7B",
      dark: "#E04848",
      contrastText: "#FFFFFF",
      gradient: "linear-gradient(90deg, #FF7B7B 0%, #FF5252 100%)",
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF",
      "tint-2": "rgba(0, 0, 0, 0.12)",
      dark: "rgba(0, 0, 0, 0.06)",
      //   darker: "#rgba(0, 0, 0, 0.10)",
      light: "#D9D9D9",
    },
    icon: {
      warning: "#755800",
    },
  },
  typography: {
    h2: {
      fontFamily: "Roboto",
      fontSize: "2.125rem",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "123.5%" /* 41.99px */,
      letterSpacing: "0.015625rem", // 0.25px ÷ 16px = 0.015625rem
      fontFeatureSettings: '"liga" off, "clig" off',
    },
    h4: {
      fontFamily: "Roboto",
      fontSize: "1.25rem", // 20px ÷ 16px = 1.25rem
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "160%",
      letterSpacing: "0.009375rem", // 0.15px ÷ 16px = 0.009375rem
      fontFeatureSettings: '"liga" off, "clig" off',
    },
    h5: {
      fontFamily: "Roboto",
      fontSize: "24px", // 20px ÷ 16px = 1.25rem
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "normal",
      letterSpacing: "0.009375rem", // 0.15px ÷ 16px = 0.009375rem
      fontFeatureSettings: '"liga" off, "clig" off',
    },
    body1: {
      fontFamily: "Roboto",
      fontSize: "1rem", // 16px ÷ 8px = 2rem
      fontStyle: "normal",
      lineHeight: "150%",
      letterSpacing: "0.009375rem", // 0.15px ÷ 16px = 0.009375rem
      fontFeatureSettings: '"liga" off, "clig" off',
    },
    caption: {
      fontFamily: "Roboto",
      lineHeight: "16px",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: "inherit",
      },
      styleOverrides: {
        root: () => ({
          padding: "8px 12px",
          variants: [
            {
              // TODO:: match variant name with UX theme when it's added to shared palette
              props: { variant: "outlined-contained" },
              style: {
                border: "1px solid",
                backgroundColor: alpha("#9147FF", 0.5),
                borderColor: "#9147FF",
                "&:hover": {
                  backgroundColor: "#9147FF",
                },
              },
            },
          ],
        }),
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: sharedPalette.primary.main,
          textDecoration: "none",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#f0f0f0",
          color: "#363636",
          boxShadow:
            "0px 1px 3px 0px #0000001F, 0px 1px 1px 0px #00000024, 0px 2px 1px -1px #00000033",
        },
        arrow: {
          "&::before": {
            backgroundColor: "#f0f0f0",
            boxShadow:
              "1px 1px 3px 0px #0000001F, 1px 1px 1px 0px #00000024, 2px 2px 1px -1px #0003",
          },
        },
      },
    },
  },
});
